import type { FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer.ts';
import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import type { DetectedLink, LinkType } from './link-detector.ts';

export const IntegrationLinkSpotlightLoadable: LoadableType<
	Omit<
		{
			detectedLinks: DetectedLink[];
			newLinkTypes: LinkType[];
			newLinks: DetectedLink[];
			onClose: () => void;
			flags: FlagsStateContainer;
			cloudId: string;
			atlassianAccountId: string | null;
			analyticsContext?: string;
		},
		'flags'
	>
> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-IntegrationLinkSpotlight" */ '../src/IntegrationLinkSpotlight.tsx'
			)
		).IntegrationLinkSpotlight,
	loading: () => null,
});
